"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PanelsDisplayTable = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.concat.js");
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FemaGoTable = _interopRequireDefault(require("../../go/components/common/tables/femaGoTable/FemaGoTable"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * PanelsDisplayTable
 *
 * PROPS:
 *     columnHeaders: an array of column headers
 *     columnKeys: an array of keys of row data object to be displayed in columns
 *     columnWidths: array of widths of the columns (sum must be <= 16)
 *     rows: array of objects to display. Objects must contain keys that are listed in the headers array
 */

var PanelsDisplayTable = function PanelsDisplayTable(_ref) {
  var columnHeaders = _ref.columnHeaders,
    rows = _ref.rows,
    columnWidths = _ref.columnWidths,
    columnKeys = _ref.columnKeys,
    summary = _ref.summary;
  return /*#__PURE__*/_react.default.createElement(_FemaGoTable.default, {
    type: "static",
    summary: summary
  }, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Header, null, /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Row, null, _lodash.default.map(columnHeaders, function (h, idx) {
    return /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.HeaderCell, {
      key: "column-".concat(h, "-").concat(idx),
      width: columnWidths[idx],
      arialabel: h
    }, h);
  }))), /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Body, null, _lodash.default.map(rows, function (r, index) {
    return /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.Row, {
      key: "row-".concat(r, "-").concat(index)
    }, _lodash.default.map(columnKeys, function (h, idx) {
      return /*#__PURE__*/_react.default.createElement(_FemaGoTable.default.TextCell, {
        key: "".concat(r[h], "-").concat(idx),
        scope: "col"
      }, r[h]);
    }));
  })));
};
exports.PanelsDisplayTable = PanelsDisplayTable;
PanelsDisplayTable.propTypes = {
  columnHeaders: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  rows: _propTypes.default.arrayOf(_propTypes.default.object),
  columnWidths: _propTypes.default.arrayOf(_propTypes.default.number),
  columnKeys: _propTypes.default.arrayOf(_propTypes.default.string).isRequired,
  summary: _propTypes.default.string
};
var _default = PanelsDisplayTable;
exports.default = _default;